import axiosClient from "utils/axios";
import type { ApiList, ApiResponse } from "types/api.types";
import type { Notification } from "../types/notification.types";

export const getNotifications = async ({
  page = 1,
  limit = 20,
  unreadOnly,
}: {
  page?: number;
  limit?: number;
  unreadOnly?: boolean;
} = {}) => {
  const { data } = await axiosClient.get<ApiResponse<ApiList<Notification[]>>>(
    "/notifications",
    { params: { page, limit, ...(unreadOnly ? { unreadOnly: "true" } : {}) } },
  );
  return data;
};

export const getUnreadCount = async () => {
  const { data } = await axiosClient.get<ApiResponse<{ count: number }>>(
    "/notifications/unread-count",
  );
  return data;
};

export const markRead = async (id: number) => {
  const { data } = await axiosClient.patch<ApiResponse<Notification>>(
    `/notifications/${id}/read`,
  );
  return data;
};

export const markAllRead = async () => {
  const { data } = await axiosClient.patch<ApiResponse<null>>(
    "/notifications/read-all",
  );
  return data;
};
